/**
 * Spodek souhrnu objednávky — jedna funkce pro košík i pokladnu (KAN-2013).
 *
 * Test21: košík s mezisoučtem 330 Kč, dorovnáním minima 170 Kč a DPH 105 Kč
 * hlásil „Celkem bez DPH 330 Kč" — čistou částku si skládal sám jako
 * ``mezisoučet + příplatky`` a dorovnání (KAN-738) do ní zapomněl. Pokladna
 * ji brala jako ``celkem − DPH`` a měla pravdu (500 Kč). Obě obrazovky teď
 * berou řádky odsud: čistá částka je VŽDY ``celkem − DPH`` ze serveru, takže
 * cokoli, co server do celku započte (dorovnání, příplatky, sleva), je v ní
 * taky, a nový druh řádku ji nerozbije.
 *
 * Částky jsou v minor jednotkách měny (haléře); formátuje volající.
 */

import type { VatDisplayMode } from "@/lib/vatDisplay";

export interface OrderSummaryTotalsInput {
  /** Celkem k úhradě (s DPH) — jak ho spočítal server. */
  totalMinor: number;
  /** DPH z celku; 0 = obchod/objednávka DPH neúčtuje (nebo reverse charge). */
  vatMinor: number;
  /** Přepínač „S DPH | Bez DPH" zákazníka. */
  vatMode: VatDisplayMode;
}

export interface OrderSummaryTotals {
  /** Účtuje se DPH (kreslí se řádek DPH a úhrn „s DPH"). */
  hasVat: boolean;
  /** Informativní řádek „Celkem bez DPH" PŘED DPH (jen v režimu bez DPH). */
  showNetRow: boolean;
  /** Celkem bez DPH = celkem − DPH. */
  netMinor: number;
  vatMinor: number;
  /** Úhrn — vždy částka k úhradě, nikdy čistá cena (KAN-1783). */
  grossMinor: number;
}

export function orderSummaryTotals({
  totalMinor,
  vatMinor,
  vatMode,
}: OrderSummaryTotalsInput): OrderSummaryTotals {
  const vat = Math.max(0, vatMinor);
  const hasVat = vat > 0;
  return {
    hasVat,
    showNetRow: hasVat && vatMode === "net",
    netMinor: totalMinor - vat,
    vatMinor: vat,
    grossMinor: totalMinor,
  };
}
